import { css, SerializedStyles } from '@emotion/react'
import styled from '@emotion/styled'

import InputBase from '@src/components/inputs/InputBase'
import React, { forwardRef, memo, ReactNode } from 'react'

type FileSelectorProps = {
	label?: string | ReactNode
	buttonTxt?: string
	wrapperStyle?: SerializedStyles
	labelStyle?: SerializedStyles
	uploadBtnStyle?: SerializedStyles
	errorMsg?: string
	isError?: boolean
} & React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>

const FileSelector = (
	{
		label,
		buttonTxt,
		wrapperStyle,
		labelStyle,
		uploadBtnStyle,
		errorMsg,
		...rest
	}: FileSelectorProps,
	ref: React.Ref<HTMLInputElement>,
) => {
	return (
		<InputBase css={[wrapperBasicStyle, wrapperStyle]}>
			{label && <InputLabel css={labelStyle}>{label}</InputLabel>}
			<div>
				{errorMsg && <ErrorMsg>{errorMsg}</ErrorMsg>}
				<LabelStyle htmlFor={rest.id} css={uploadBtnStyle}>
					<input type="file" ref={ref} {...rest} />
					{buttonTxt}
				</LabelStyle>
			</div>
		</InputBase>
	)
}

const wrapperBasicStyle = css`
	display: flex;
	flex-direction: row;
	padding: 1rem 0;
`

const InputLabel = styled.label`
	flex: 0 0 auto;
	display: inline-flex;
	align-items: center;
	font-size: 1.3rem;
	font-weight: 600;
	line-height: 2.2rem;
	width: 13rem;
	height: 3.4rem;
`

const LabelStyle = styled.label`
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: 600;
	font-size: 12px;
	color: #363644;
	height: 34px;
	width: 64px;
	border: 1px solid #e7e7ed;
	cursor: pointer;

	input {
		display: none;
	}
`

const ErrorMsg = styled.div`
	color: #de0000;
	font-size: 1.2rem;
	font-weight: 600;
`
export default memo(forwardRef<HTMLInputElement, FileSelectorProps>(FileSelector))
